import { ActionType, createAction } from 'typesafe-actions';
import { Loan } from '../types/loan/Loan';
import { EditLoanPopupModel } from '../types/loan/EditLoanFormModel';
import { UpsertLoanModel } from '../types/loan/UpsertLoanModel';
import { LoanMonitorRightSidePanelTabType } from '../types/loan/LoanMonitorRightSidePanelTabType';

const init = createAction('loan/INIT');
const search = createAction('loan/SEARCH');
const loadNextPage = createAction('loan/LOAD_NEXT_PAGE');
const nextPageRequest = createAction('loan/NEXT_PAGE_REQUEST');
const nextPageRequestSuccess = createAction(
    'loan/NEXT_PAGE_REQUEST_SUCCESS',
    resolve => (loans: Loan[], totalRecordNumber: number) => resolve({ loans, totalRecordNumber }),
);
const nextPageRequestError = createAction('loan/NEXT_PAGE_REQUEST_ERROR');
const request = createAction('loan/REQUEST');
const requestSuccess = createAction(
    'loan/REQUEST_SUCCESS',
    resolve => (loans: Loan[], totalRecordNumber: number) => resolve({ loans, totalRecordNumber }),
);
const requestError = createAction('loan/REQUEST_ERROR');
const resetLoans = createAction('loan/RESET_LOANS');
const reset = createAction('loan/RESET');
const deleteLoan = createAction(
    'loan/DELETE',
    resolve => (id: number) => resolve({ id }),
);
const deleteLoanSuccess = createAction(
    'loan/DELETE_SUCCESS',
    resolve => (id: number) => resolve({ id }),
);
const loanUpdated = createAction(
    'loan/UPDATED',
    resolve => (id: number, model: EditLoanPopupModel) => resolve({ id, model }),
);
const loanUpdatedSuccess = createAction(
    'loan/UPDATED_SUCCESS',
    resolve => (loan?: Loan) => resolve({ loan }),
);
const loanUpdatedError = createAction('loan/UPDATED_ERROR');
const adminLoanSave = createAction(
    'loan/ADMIN_LOAN_SAVE',
    resolve => (id: number | undefined, model: UpsertLoanModel) => resolve({ id, model }),
);
const upsertLoanSuccess = createAction(
    'loan/UPSERT_SUCCESS',
    resolve => (loan: Loan) => resolve({ loan }),
);
const upsertLoanError = createAction('loan/UPSERT_ERROR');
const upsertLoanReset = createAction('loan/UPSERT_RESET');
const issuerSearchChange = createAction(
    'loan/ISSUER_SEARCH_CHANGE',
    resolve => (issuerSearch: string[]) => resolve({ issuerSearch }),
);
const sortChange = createAction(
    'loan/SORT_CHANGE',
    resolve => (sortingField: string, sortDirection: string) => resolve({ sortingField, sortDirection }),
);
const exportLoans = createAction('loan/EXPORT');
const exportLoansSuccess = createAction('loan/EXPORT_SUCCESS');
const exportLoansError = createAction('loan/EXPORT_ERROR');
const activeLoanChange = createAction(
    'loan/ACTIVE_LOAN_CHANGE',
    resolve => (loanId?: number, rightSidePanelTab?: LoanMonitorRightSidePanelTabType) =>
        resolve({ loanId, rightSidePanelTab }),
);
const restoreFilterQueryString = createAction('loan/RESTORE_FILTER_QUERY_STRING');
const setShouldRestoreFiltersQueryString = createAction(
    'loan/SET_SHOULD_RESTORE_FILTERS_QUERY_STRING',
    resolve => (value: boolean) => resolve({ value }),
);

export type TLoanActions = ActionType<(typeof loanActions)[keyof typeof loanActions]>;

export const loanActions = {
    init,
    reset,
    search,
    loadNextPage,
    nextPageRequest,
    nextPageRequestSuccess,
    nextPageRequestError,
    request,
    requestSuccess,
    requestError,
    resetLoans,
    deleteLoan,
    deleteLoanSuccess,
    loanUpdated,
    loanUpdatedSuccess,
    loanUpdatedError,
    adminLoanSave,
    upsertLoanSuccess,
    upsertLoanError,
    upsertLoanReset,
    issuerSearchChange,
    sortChange,
    exportLoans,
    exportLoansSuccess,
    exportLoansError,
    activeLoanChange,
    restoreFilterQueryString,
    setShouldRestoreFiltersQueryString,
};
